/*des 修改产品试用申请弹框
 *date 2018-1-10
 *author lileilei
 */
'use strict';
angular.module('editApplictionModule', [])
    .controller('editApplictionCtrl', ["$scope", "$q", "trsHttpService", "$modalInstance", "item", "$filter", "modalDialog",
        function($scope, $q, trsHttpService, $modalInstance, item, $filter, modalDialog) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             */
            function initStatus() {
                $scope.status = {

                };
            }

            function initData() {
                if (angular.isDefined(item)) {
                    $scope.data = angular.copy(item);
                }
            }
            /**
             * [cancel description]点击取消
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description]确定
             */
            $scope.confirm = function() {
                var data = $scope.data;
                var param = {
                    serviceid: "mlf_trialapplication",
                    methodName: 'updateTrialApplication',
                    ObjectId: item.TRIALAPPLICATIONID,
                    CONTACTS: data.CONTACTS,
                    CONTACTNUMBER: data.CONTACTNUMBER,
                    COMPANYNAME: data.COMPANYNAME,
                    EMAIL: data.EMAIL,
                    AREA: data.AREA,
                    STATUS: data.STATUS
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), param, 'post').then(function(data) {
                    if (data.TYPE === '3') {
                        modalDialog.alertType('', data.DETAIL, 'success', false);
                        $modalInstance.close($scope.data);
                    }
                });
            };
        }
    ]);